import { CorrelatePairsQuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditAnswers from '../Editors/EditAnswers';
import GenPropQuestion from './GenPropQuestion';
import PrePostFixQuestion from './PrePostFixQuestion';

interface PostEditQuizCorrelatePairsQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PostEditQuizCorrelatePairsQuestion = (p: PostEditQuizCorrelatePairsQuestionProps) => {
    const { epc, registerClosed } = p;
    return (
        <>
            <GenPropQuestion epc={epc} registerClosed={registerClosed} />
            <EditPartContainer icon="cog" title="answers" {...epc} registerClosed={false}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "package", content: "pairs" }, editor: <EditAnswers<CorrelatePairsQuestionDownloadDto> getter={x => x.possibleAnswers} noIsCorrect inPairs /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <PrePostFixQuestion epc={epc} registerClosed={registerClosed} />
        </>
    );
}
export default PostEditQuizCorrelatePairsQuestion;